<template>
  <div class="sip_status_info">
    <div class="sip_status_green" v-html="green(pers)" />
  </div>
</template>
<script>

const green = (num) =>`
<svg viewBox="0 0 51 133" fill="none" xmlns="http://www.w3.org/2000/svg">
<!--
<g filter="url(#filter0_i)">
<path d="M0 11.5C0 10.1068 0 9.41027 0.0693154 8.82463C0.612761 4.23308 4.23308 0.612761 8.82463 0.0693154C9.41027 0 10.1068 0 11.5 0H39.5C40.8932 0 41.5897 0 42.1754 0.0693154C46.7669 0.612761 50.3872 4.23308 50.9307 8.82463C51 9.41027 51 10.1068 51 11.5V121.5C51 122.893 51 123.59 50.9307 124.175C50.3872 128.767 46.7669 132.387 42.1754 132.931C41.5897 133 40.8932 133 39.5 133H11.5C10.1068 133 9.41027 133 8.82463 132.931C4.23308 132.387 0.612761 128.767 0.0693154 124.175C0 123.59 0 122.893 0 121.5V11.5Z" fill="url(#paint0_linear)"/>
</g>
<path d="M0.5 11.5C0.5 10.0926 0.500874 9.43237 0.56585 8.88339C1.08212 4.52142 4.52142 1.08212 8.88339 0.56585C9.43237 0.500874 10.0926 0.5 11.5 0.5H39.5C40.9074 0.5 41.5676 0.500874 42.1166 0.56585C46.4786 1.08212 49.9179 4.52142 50.4342 8.88339C50.4991 9.43237 50.5 10.0926 50.5 11.5V121.5C50.5 122.907 50.4991 123.568 50.4342 124.117C49.9179 128.479 46.4786 131.918 42.1166 132.434C41.5676 132.499 40.9074 132.5 39.5 132.5H11.5C10.0926 132.5 9.43238 132.499 8.8834 132.434C4.52142 131.918 1.08212 128.479 0.56585 124.117C0.500874 123.568 0.5 122.907 0.5 121.5V11.5Z" stroke="white"/>
-->
<path class="sip_status_path_green" style="transform: translateY(${num}%)" d="M1 12.3677C16 5.27894 39.5 16.7985 50 12.3677V123C50 127.971 45.9706 132 41 132H10C5.02944 132 1 127.971 1 123L1 12.3677Z" fill="#5BAF09"/>
<g filter="url(#filter1_d)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 98C4 97.4477 4.44772 97 5 97H25C25.5523 97 26 97.4477 26 98C26 98.5523 25.5523 99 25 99H5C4.44772 99 4 98.5523 4 98Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 117.5C4.5 117.224 4.72386 117 5 117H17.4348C17.7109 117 17.9348 117.224 17.9348 117.5C17.9348 117.776 17.7109 118 17.4348 118H5C4.72386 118 4.5 117.776 4.5 117.5Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 78.5C4.5 78.2239 4.72386 78 5 78H17.4348C17.7109 78 17.9348 78.2239 17.9348 78.5C17.9348 78.7761 17.7109 79 17.4348 79H5C4.72386 79 4.5 78.7761 4.5 78.5Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 59C4 58.4477 4.44772 58 5 58H25C25.5523 58 26 58.4477 26 59C26 59.5523 25.5523 60 25 60H5C4.44772 60 4 59.5523 4 59Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 39.5C4.5 39.2239 4.72386 39 5 39H17.4348C17.7109 39 17.9348 39.2239 17.9348 39.5C17.9348 39.7761 17.7109 40 17.4348 40H5C4.72386 40 4.5 39.7761 4.5 39.5Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 20C4 19.4477 4.44772 19 5 19H25C25.5523 19 26 19.4477 26 20C26 20.5523 25.5523 21 25 21H5C4.44772 21 4 20.5523 4 20Z" fill="white"/>
</g>
<rect x="33" y="24" width="11" height="102" rx="5.5" fill="white" fill-opacity="0.46"/>
<rect x="33" y="7" width="11" height="13" rx="5.5" fill="white" fill-opacity="0.46"/>
<defs>
<filter id="filter0_i" x="0" y="0" width="51" height="133" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
</filter>
<filter id="filter1_d" x="4" y="19" width="22" height="101" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
</filter>
<linearGradient id="paint0_linear" x1="25.5" y1="0" x2="25.5" y2="133" gradientUnits="userSpaceOnUse">
<stop stop-color="#4E737E"/>
<stop offset="1" stop-color="#435C64"/>
</linearGradient>
</defs>
</svg> 
`
export default {
  name: 'Status',
  data() {
    return {
      green,
      pers: 90,
    }
  },
  methods: {
    progress() {
      let id = setInterval(()=>{
        if(this.pers > 0) {
          this.pers--
        }else{
          this.$emit('refill', true)
          this.pers = 90
          clearInterval(id)
        }
      },80)
    }
  }
}
</script>

<style lang="stylus">
.sip_status_info
  width 51px
  height 145px
  // background-color red
  position relative
  display inline-block
  border-radius: 10px;
  background: linear-gradient(180deg, #4E737E 0%, #435C64 100%);
  border: 1px solid #FFFFFF;
  // box-sizing: border-box;
  // box-shadow: inset 0px 4px 0px rgba(0, 0, 0, 0.25);
  overflow-y hidden
  @media screen and (max-width: 900px)
    height 137px
  .sip_status_green
    width 100%
    position absolute
    bottom 0
    left 0
    @media screen and (max-width: 900px)
      transform translateY(10px)

    // &:after
    //   content ''
    //   width 100%
    //   height 30px
    //   background #5baf09
    //   position absolute
    //   bottom 0
    //   left 0
    .sip_status_path_green
      transform translateY(80px)
      transition transform .5s
      position relative


</style>